export const PHOTOS = {
  clayReception: "/photos/clayReception-1400.webp",
  fryExterior: "/photos/fryExterior-1400.webp",
  fryReception: "/photos/fryReception-1400.webp",
  fryClassroom: "/photos/fryClassroom-1400.webp",
  fryKitchen: "/photos/fryKitchen-1400.webp",
  clayGarden: "/photos/clayGarden-1400.webp",
  clayFoam: "/photos/clayFoam-1400.webp",
  clayPlayground: "/photos/clayPlayground-1400.webp",
  clayFishing: "/photos/clayFishing-1400.webp",
  fryToddlerPlayground: "/photos/fryToddlerPlayground-1400.webp",
  frySplash: "/photos/frySplash-1400.webp",
  fryPrekPlayground: "/photos/fryPrekPlayground-1400.webp",
  fryBus: "/photos/fryBus-1400.webp",
  fryAfterschoolPlayground: "/photos/fryAfterschoolPlayground-1400.webp",
};

export const TESTIMONIALS = [
  {
    id: "brittany",
    name: "Brittany M.",
    location: "clay",
    quote: "I love how they do extracurricular activities to keep children engaged and having fun, which creates that positive social environment for everyone. The staff has always been friendly, attentive and supportive. This daycare is very clean and everyone is a team! My daughter has always felt safe and not afraid to speak to any teacher or staff member there.",
  },
  {
    id: "shavonne",
    name: "Shavonne R.",
    quote: "This is a wonderful and trustworthy daycare. We've been attending for a few years, from infant to preschool, and all the teachers are great and positive. They keep me updated and answer any questions I have — it puts me at ease knowing my children are cared for and in good hands. My children enjoy coming to daycare.",
  },
  {
    id: "diana",
    name: "Diana A. — The Alcantara Family",
    quote: "As a mom, leaving your child in someone else's care can be hard, but Learning & Beyond has given us so much peace and confidence. Thank you to our wonderful director and to Ms. Maggie, whose warm smile greets us at the door every day. Knowing that everyone knows him by name truly means the world to us.",
  },
  {
    id: "melissa",
    name: "Melissa K.",
    quote: "My son who is almost 2 has been at Learning and Beyond for about a year and I am very pleased with the care he receives. Communication is consistent and timely. Teachers come up with creative lessons to introduce life skills as well as an introduction to academia. A wonderful place with a wonderful staff and the most caring owners and Director.",
  },
];

export const GALLERY = [
  { id: "clay-playground", src: PHOTOS.clayPlayground, location: "clay", ratio: "aspect-[4/3]" },
  { id: "fry-splash", src: PHOTOS.frySplash, location: "fry", ratio: "aspect-[4/3]" },
  { id: "fry-classroom", src: PHOTOS.fryClassroom, location: "fry", ratio: "aspect-[3/4]" },
  { id: "clay-foam", src: PHOTOS.clayFoam, location: "clay", ratio: "aspect-[4/3]" },
  { id: "fry-bus", src: PHOTOS.fryBus, location: "fry", ratio: "aspect-[4/3]" },
  { id: "clay-garden", src: PHOTOS.clayGarden, location: "clay", ratio: "aspect-[4/3]" },
  { id: "fry-prek-playground", src: PHOTOS.fryPrekPlayground, location: "fry", ratio: "aspect-[3/4]" },
  { id: "fry-kitchen", src: PHOTOS.fryKitchen, location: "fry", ratio: "aspect-[4/3]" },
  { id: "clay-fishing", src: PHOTOS.clayFishing, location: "clay", ratio: "aspect-[4/3]" },
  { id: "fry-toddler-playground", src: PHOTOS.fryToddlerPlayground, location: "fry", ratio: "aspect-[4/3]" },
  { id: "fry-exterior", src: PHOTOS.fryExterior, location: "fry", ratio: "aspect-[4/3]" },
  { id: "clay-reception", src: PHOTOS.clayReception, location: "clay", ratio: "aspect-[3/4]" },
  { id: "fry-afterschool-playground", src: PHOTOS.fryAfterschoolPlayground, location: "fry", ratio: "aspect-[4/3]" },
  { id: "fry-reception", src: PHOTOS.fryReception, location: "fry", ratio: "aspect-[4/3]" },
];

export const LOCATIONS = [
  {
    id: "clay",
    name: "Clay Road Center",
    short: "Clay Rd.",
    address: "19600 Clay Rd., Katy, TX 77449",
    phone: "(832) 464-7787",
    phoneHref: "tel:+18324647787",
    email: "info@labclay.com",
    assistance: ["ccs", "military"],
    badge: "Texas Rising Star — Highest 4-Star Rating",
    photo: PHOTOS.clayPlayground,
    photoAlt: "Clay Road Center front office reception with rocket wall mural",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=19600+Clay+Rd+Katy+TX+77449",
    mapEmbed: "https://www.google.com/maps?q=19600+Clay+Rd,+Katy,+TX+77449&output=embed",
  },
  {
    id: "fry",
    name: "N Fry Road Center",
    short: "N Fry Rd.",
    address: "3750 N Fry Rd., Katy, TX 77449",
    phone: "(832) 205-8327",
    phoneHref: "tel:+18322058327",
    email: "info@lab-fry.com",
    assistance: ["ccs", "military", "tefa"],
    badge: "Modern Early Learning Facility",
    photo: PHOTOS.fryExterior,
    photoAlt: "N Fry Road Center building exterior",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=3750+N+Fry+Rd+Katy+TX+77449",
    mapEmbed: "https://www.google.com/maps?q=3750+N+Fry+Rd,+Katy,+TX+77449&output=embed",
  },
];

export const HOURS = "Mon – Fri · 6:00 AM – 6:00 PM";

export const SCHOOLS = [
  "McRoberts",
  "Roades",
  "Walker",
  "Emery",
  "Sheridan",
  "Golbow",
  "Morton Ranch",
  "Sundown",
  "Franz",
  "Stevens",
  "Schmalz",
  "M Robinson",
  "Brosnahan",
];

export const MANTRAS = ["SMART", "LOVED", "HELPFUL", "POWERFUL", "BRAVE", "KIND", "TRUTHFUL"];

export const AGE_GROUPS = [
  "6 weeks - 12 months (Infant)",
  "1 - 2 years (Toddler)",
  "3 - 5 years (Preschool)",
  "5 - 12 years (School Age)",
];

export const TIME_SLOTS = [
  "8:00 - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 - 3:00 PM",
  "3:00 - 5:30 PM",
];

export const PROGRAM_OPTIONS = [
  "Infants (6 weeks - 12 months)",
  "Toddlers (1 - 2 years)",
  "Preschool (3 - 5 years)",
  "Before/After School + Transportation (5 - 12 years)",
];
